<div class="alert alert-danger">
  <h3>Not Authorized</h3>
  <div>
    <span *ngIf="targetUrl">Your are not authorized to access <b>{{targetUrl}}</b>. </span>
    <span *ngIf="!targetUrl">Your are not authorized to access the target resource. </span>
    Please, contact your Fabric administrator.
  </div>
</div>
